// extracted by mini-css-extract-plugin
module.exports = {"arrowKeyImage":"HowToMove_arrowKeyImage__CoIuI","lookAroundImage":"HowToMove_lookAroundImage__P-VJ0","closeDiv":"HowToMove_closeDiv__3E8Us"};